import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "panel", "progress"]
  static values = { index: { type: Number, default: 0 }, autoplay: { type: Number, default: 0 } }

  connect() {
    this.render()
    this.schedule()
  }

  disconnect() {
    this.cancel()
  }

  select(event) {
    const index = event.params.index
    this.autoplayValue = 0
    this.cancel()
    this.indexValue = index === undefined ? this.itemTargets.indexOf(event.currentTarget) : index
  }

  pause() {
    this.cancel()
  }

  resume() {
    this.schedule()
  }

  indexValueChanged() {
    this.render()
  }

  render() {
    if (!this.hasItemTarget) return

    this.itemTargets.forEach((el, i) => el.classList.toggle("is-active", this.indexFor(el, i) === this.indexValue))
    this.panelTargets.forEach((el, i) => el.classList.toggle("is-active", this.indexFor(el, i) === this.indexValue))
    this.restartProgress()
  }

  indexFor(element, fallback) {
    const index = element.dataset.showcaseIndexParam
    return index === undefined ? fallback : Number(index)
  }

  restartProgress() {
    if (!this.hasProgressTarget) return

    this.progressTargets.forEach((el, i) => {
      el.style.animation = "none"
      void el.offsetWidth
      el.style.animation = this.indexFor(el, i) === this.indexValue && this.autoplayValue > 0 ? `showcase-progress ${this.autoplayValue}ms linear forwards` : ""
    })
  }

  schedule() {
    this.cancel()
    if (this.autoplayValue <= 0) return

    this.timer = setTimeout(() => {
      this.indexValue = (this.indexValue + 1) % this.itemTargets.length
      this.schedule()
    }, this.autoplayValue)
  }

  cancel() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = null
  }
}
